import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import EditLayoutModal from './layout/EditLayoutModal';

const ProfileEdit = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decoded = jwt_decode(token);
      if (decoded?.id) {
        setUserId(decoded.id);
      } else {
        navigate('/login');
      }
    } catch (error) {
      console.error('Token validation error:', error);
      navigate('/login');
    }
  }, [navigate]);

  const handleDone = () => {
    navigate('/profile');
  };

  if (!userId) {
    return (
      <div className='text-center mt-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <EditLayoutModal
      show={true}
      onHide={handleDone}
      objectName='user'
      id={userId}
      onSave={handleDone}
      onCancel={handleDone}
      useProfileLayout={true}
    />
  );
};

export default ProfileEdit;
